import * as React from "react"
import styles from './styles.module.scss'

export const Success = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24.64 22.73"
        xmlSpace="preserve"
        width="1em" height="1em" fill="currentColor"
        className={styles.success}
    >
        <path
            d="M16.9 3.78c-1.09-.66-2.27-1.09-3.54-1.22-2.95-.31-5.5.56-7.58 2.7-1.31 1.34-2.09 2.96-2.39 4.82-.05.32-.06.64-.09.96-.01.08-.03.16-.04.24v.32c.02.09.04.17.04.26.24 3.54 1.97 6.1 5.13 7.71.96.49 2 .73 3.08.84.21.02.43.04.64.05h.21c.09-.02.18-.04.27-.04 1.36-.04 2.64-.38 3.82-1.04 2.49-1.37 4.05-3.46 4.6-6.26.73-3.67-.96-7.42-4.15-9.34zm.22 5.35-6.1 6.1c-.17.17-.17.17-.34.01L7.41 12c-.05-.05-.1-.11-.17-.18.05-.05.09-.11.13-.15.4-.4.81-.79 1.21-1.2.1-.1.17-.1.27 0 .6.6 1.22 1.2 1.82 1.8.05.05.1.1.16.15.06-.06.11-.1.16-.15l4.61-4.61c.17-.17.17-.17.34 0 .4.39.8.79 1.2 1.18.03.03.06.07.11.12-.04.07-.08.12-.13.17z"
        />
    </svg>
)

